<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {FormSlice} from '@prismicio-types';
    import FormDefault from './variations/FormDefault.vue';
    import FormWithAccordion from './variations/FormWithAccordion.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations.js';

    const props = defineProps(getSliceComponentProps<FormSlice>());

    const variationComponents = {
        default: FormDefault,
        formWithAccordion: FormWithAccordion,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>
